import Vue from 'vue'
import LogRocket from 'logrocket'
import Router from 'vue-router'
import { setSentryUser, unsetSentryUser } from '@/lib/sentry'
import store from '@/lib/store'
import Login from '@/components/login/login'
import Notifications from '@/components/notifications/notifications'
import Home from '@/components/Home/Home'
import HomeTasks from '@/components/Home/Tasks'
import HomeRecentActivity from '@/components/Home/RecentActivity'
import HomeFocus from '@/components/Home/Focus/Focus'
import Contacts from '@/components/Contacts/Contacts'
import Meeting from '@/components/meetings/meeting'
import Meetings from '@/components/meetings/meetings'
import LiveCoach from '@/components/live-coach/live-coach'
import PhoneController from '@/components/phone-controller/phone-controller'
import RepCall from '@/components/rep-call/rep-call'
import LiveCoachCall from '@/components/live-coach-call/live-coach-call'
import SMS from '@/components/sms/sms'
import ActivitySummaryRoute from '@/components/activity-summary/activity-summary-route'
import ErrorPage from '@/components/error-page/error-page'
import Messages from '@/components/messages/messages'
import NewMessage from '@/components/messages/new-message/new-message'
import Logout from '@/components/Logout/Logout'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        { path: '', component: HomeRecentActivity },
        { path: 'tasks', component: HomeTasks },
        { path: 'focus', component: HomeFocus }
      ]
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/notifications',
      component: Notifications
    },
    {
      path: '/contacts',
      component: Contacts
    },
    {
      path: '/meetings',
      component: Meetings
    },
    {
      path: '/meetings/:id',
      name: 'meeting',
      component: Meeting
    },
    {
      path: '/live-coach',
      component: LiveCoach
    },
    {
      path: '/phone-controller',
      component: PhoneController
    },
    {
      path: '/rep-call',
      component: RepCall
    },
    {
      path: '/live-coach-call',
      component: LiveCoachCall
    },
    {
      path: '/sms',
      component: SMS
    },
    {
      path: '/activity-summary',
      component: ActivitySummaryRoute
    },
    {
      path: '/error-page',
      component: ErrorPage
    },
    {
      path: '/messages',
      component: Messages
    },
    {
      path: '/new-message',
      component: NewMessage
    },
    {
      path: '/logout',
      component: Logout
    }
  ]
})

let sentryUserSet = false

router.beforeEach((to, from, next) => {
  // @todo: Remove this after all users are on Jiminny extension >= v2.12.1
  if (to.hash && to.hash.startsWith('#phone-controller')) {
    return next(`/${to.hash.substring(1)}`)
  }

  const token = store.get('token')
  const publicPage = ['/login', '/phone-controller'].includes(to.path)
  const privatePage = !publicPage

  if (privatePage && !token) {
    return next('/login')
  }

  const user = store.get('user')

  if (user && !sentryUserSet) {
    const { id, name, email } = user
    setSentryUser({id, email})
    LogRocket.identify(id, {
      name,
      email
    })
    sentryUserSet = true
  } else if (sentryUserSet && !user) {
    unsetSentryUser()
    LogRocket.identify()
    sentryUserSet = false
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/plugins/router.js